import BaseAPI from '@/apis/base/baseApi';

class ReportDesignAPI extends BaseAPI { 
    apiName = 'ReportDesign';

    /**
     * Lấy link sửa
     * @param {*} reportFile 
     * @param {*} reportType 
     * @param {*} edited 
     * @param {*} key 
     * @returns 
     * nvtoan2 01/08/2023
     */
    getDesignLink(reportFile, reportType, edited, auth, reportId) {
        return `${this.getAPIUrl()}?file=${reportFile}&type=${reportType}&edited=${edited}&reportId=${reportId}&auth=${auth}`;
    }
}

export default new ReportDesignAPI();